import { sharedStore } from '@ncl/rootStore/rootStore.model';
import { logNetworkError, logEvent } from '../utils';

const RETRY_TIMEOUT = 1000;

export function retryAxios(config, axiosInstance) {
  const MAX_RETRY_ATTEMPTS = 8;
  const ATTEMPTS_TO_DISPLAY_MODAL = 3;

  const { numberOfRequests } = config;

  if (numberOfRequests === ATTEMPTS_TO_DISPLAY_MODAL && !sharedStore.displayConnectionModal) {
    logEvent('connection-modal-open');
    sharedStore.openConnectionModal();
  }

  if (numberOfRequests >= MAX_RETRY_ATTEMPTS) {
    sharedStore.closeConnectionModal();
    return setErrorBasedOnConnectionStatus();
  }

  return new Promise((resolve) => {
    setTimeout(() => {
      const retryAttempt = numberOfRequests + 1;
      resolve(axiosInstance({ ...config, numberOfRequests: retryAttempt }));
    }, RETRY_TIMEOUT);
  });
}

export function formatRequestErrorResponse(response, connectionAborted, ignoreBehavior) {
  const { status: httpStatusCode, data: apiResponse } = response || {};

  const data = apiResponse?.data || {};
  const errors = apiResponse?.errors || [];
  const unauthorized = httpStatusCode === 401;
  const unexpected = errors.length === 0;

  if (unauthorized && unexpected) {
    window.location.assign('/conta/login?continue=%2Fpanel');
    return false;
  }

  let formattedErrors = connectionAborted
    ? [{ message: 'Server timeout.', code: 408 }]
    : [{ message: 'Erro inesperado. Tente novamente mais tarde.', code: 0 }];

  const errorCodes =
    !connectionAborted && !unexpected && !unauthorized
      ? errors.map((err) => parseInt(err.code, 10))
      : [];

  if (!unexpected) {
    formattedErrors = filterAxiosErrorMessages(errors);
  }

  if (!ignoreBehavior || !ignoreBehavior.logrocket) {
    logNetworkError(formattedErrors);
  }

  if (ignoreBehavior && ignoreBehavior.formatResponse) {
    return { error: true, errors: [], data, errorCodes: [] };
  }

  return { error: true, errors: formattedErrors, data, errorCodes };
}

function filterAxiosErrorMessages(errors) {
  const errorsMap = require('../../../json/errors.json');
  const filtered = [];

  errors.forEach((err) => {
    let { message } = err;

    const customError = errorsMap.find((e) => e.code === parseInt(err.code, 10)) || {};
    const { customMessage } = customError;

    if (customMessage) {
      message = customMessage;
    }

    filtered.push({ ...err, message, code: parseInt(err.code, 10) });
  });

  return filtered;
}

export function setErrorBasedOnConnectionStatus() {
  const name = navigator.onLine ? 'NetworkError' : 'UserOffline';
  sharedStore.addError({ name });
}

/* src: https://dev.to/goenning/how-to-retry-when-react-lazy-fails-mb5 */
/* istanbul ignore next */
export function retryLazyLoading(fn, retriesLeft = 5) {
  return new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch(() => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            // reject('maximum retries exceeded');
            sharedStore.addError({ name: 'ChunkFailed' });
            return;
          }

          // Passing on "reject" is the important part
          retryLazyLoading(fn, retriesLeft - 1).then(resolve, reject);
        }, RETRY_TIMEOUT);
      });
  });
}

export function addHttpInterceptors(instance, interceptors) {
  instance.interceptors.response.use(interceptors.response.success, (error) => {
    return interceptors.response.error(error, instance);
  });
  instance.interceptors.request.use(interceptors.request);
}
